import React from "react";
import DisplayError from "../../common/DisplayError";
import "./TextField.css";
import type { StandardFieldProps } from "../types";
import { useFormContext } from "react-hook-form";

const TextField: React.FC<StandardFieldProps> = (props) => {
  const form = useFormContext();
  const { register } = form;
  return (
    <React.Fragment>
      <div>
        <label htmlFor={props.name} className={"hidden"}>
          {props.name}
        </label>
        <input
          id={props.name}
          type={props.type || "text"}
          className="form-control"
          placeholder={props.placeholder}
          {...register(props.name, props.validationsObject)}
        />
      </div>
      <DisplayError
        errorCondition={props.error}
        errorMessage={props.error && props.error.message}
      />
    </React.Fragment>
  );
};

export default TextField;
